<!-- ALERT & CONFIRM DIALOG -->
<p-confirmDialog [style]="{width: '450px'}"></p-confirmDialog>
<p-toast></p-toast>



<!-- OVERLAY SCREEN-->
<div *ngIf="blocked " class="overlay">
    <img src="assets/layout/images/tovlogo.png" alt="{{translations.lbl_loading}}" class="loading-image" />
    <span style="color: white; font-size: large;">{{translations.lbl_loading}}</span>
</div>

<!-- MAIN CONTAINER -->
<div class="card" *ngIf="this.translations != null">

    <!-- TOOLBAR -->
    <p-toolbar styleClass="p-mb-4">
        <ng-template pTemplate="left">

            <!-- BACK BUTTON -->
            <button pButton pRipple label="{{translations.lbl_go_Back}}" icon="pi pi-chevron-left"
                class="p-button-warning p-mr-2" (click)="goBack()"></button>

            <!-- SAVE BUTTON -->
            <button pButton pRipple icon="pi pi-save" class="p-button-success p-mr-2"
                [pTooltip]="translations.lbl_add + ' ' + translations.lbl_or + ' ' + translations.lbl_update + ' ' + translations.lbl_video"
                (click)="createUpdateVideo()"></button>
        </ng-template>
    </p-toolbar>

    <!-- MAIN CONTENT -->
    <div class="p-grid">

        <!-- CREATE FORM -->
        <div class="p-col-12 p-md-6">
            <p-panel [header]="translations.lbl_detail + ' ' + translations.lbl_coordination">
                <div class="p-fluid">
                    <ng-container *ngTemplateOutlet="infoTemplateCreate"></ng-container>
                </div>
            </p-panel>
        </div>
    </div>

    <!-- CARD -->
    <ng-template #infoTemplateCreate [formGroup]="globalUserDataFormParams">
        <!-- GUIDE INFO -->
        <div class="subTitle p-d-flex p-ai-center p-jc-between p-py-2">
            <span>{{ translations.lbl_guide }}</span>
            <ng-container *ngIf="globalUserDataFormParams.get('selectedGuide').value != null; else noSelectionGuide">
                <span class="p-text-bold">
                    {{ globalUserDataFormParams.get('selectedGuide').value || " " }}</span>
            </ng-container>

            <ng-template #noSelectionGuide>
                <span class="p-text-bold">{{ translations.lbl_without + ' ' + translations.lbl_guide}}</span>
            </ng-template>
        </div>

        <!-- COORDINATION INFO -->
        <div class="subTitle p-d-flex p-ai-center p-jc-between p-py-2">
            <span>{{ translations.lbl_coordination }}</span>
            <ng-container
                *ngIf="globalUserDataFormParams.get('selectedCoordination').value != null; else noSelectionCoordination">
                <span class="p-text-bold">
                    {{ globalUserDataFormParams.get('selectedCoordination').value || " " }}</span>
            </ng-container>

            <ng-template #noSelectionCoordination>
                <span class="p-text-bold">{{ translations.lbl_without + ' ' + translations.lbl_coordination }}</span>
            </ng-template>
        </div>

    </ng-template>

    <!-- FORM TRANSFER -->
    <div class="card" [formGroup]="globalUserDataFormParams">

        <div *ngIf="globalUserDataFormParams">

            <div class="p-grid">
                <!-- 1st Section -->
                <div class="p-col-12 p-md-6 p-lg-6">
                    <div class="p-fluid">
                        <!-- NAME -->
                        <div class="p-col-12 ">
                            <div class="p-formgrid p-grid p-ai-center p-jc-between">
                                <div class="subTitle p-col-12 p-md-4">
                                    <span>{{translations.lbl_name + ' ' + translations.lbl_video }}<span
                                            *ngIf="globalUserDataFormParams.get('selectedName').value == null"
                                            style="color:red">
                                            (*)</span></span>
                                </div>

                                <div class="p-col-12 p-md-8">
                                    <input id="selectedName" formControlName="selectedName"
                                        placeholder="Solo alfanumericos (letras y numeros)" type="text" maxlength="50"
                                        pInputText>
                                </div>
                            </div>
                        </div>


                        <!-- DESCRIPTION -->
                        <div class="p-col-12 ">
                            <div class="p-formgrid p-grid p-ai-center p-jc-between">
                                <div class="subTitle p-col-12 p-md-4">
                                    <span>{{ translations.lbl_description }}<span
                                            *ngIf="globalUserDataFormParams.get('selectedDescription').value == null"
                                            style="color:red">
                                            (*)</span></span>
                                </div>

                                <div class="p-col-12 p-md-8">
                                    <input id="selectedDescription" formControlName="selectedDescription"
                                        placeholder="Solo alfanumericos (letras y numeros)" type="text" maxlength="50"
                                        pInputText>
                                </div>
                            </div>
                        </div>

                        <!-- VENDOR ID -->
                        <div class="p-col-12">
                            <div class="p-formgrid p-grid p-ai-center p-jc-between">
                                <div class="subTitle p-col-12 p-md-4">
                                    <span>{{ translations.lbl_vendor }}<span
                                            *ngIf="globalUserDataFormParams.get('selectedVendor').value == null"
                                            style="color:red">
                                            (*)</span></span>
                                </div>

                                <div class="p-col-12 p-md-8">
                                    <p-dropdown id="selectedVideoVendor"
                                        [options]="this.globalUserDataFormParams.get('selectedVideoVendor').value || []"
                                        formControlName="selectedVendor"
                                        placeholder="{{translations.lbl_select}} {{translations.lbl_video}} {{translations.lbl_vendor}}"
                                        optionLabel="descrip" optionValue="id.fieldId" [showClear]="true">
                                    </p-dropdown>
                                </div>
                            </div>
                        </div>


                        <!-- TYPE ID -->
                        <div class="p-col-12">
                            <div class="p-formgrid p-grid p-ai-center p-jc-between">
                                <div class="subTitle p-col-12 p-md-4">
                                    <span>{{ translations.lbl_add + ' ' + translations.lbl_type }}<span
                                            *ngIf="globalUserDataFormParams.get('selectedType').value == null"
                                            style="color:red">
                                            (*)</span></span>
                                </div>

                                <div class="p-col-12 p-md-8">
                                    <p-dropdown id="selectedVideoType"
                                        [options]="this.globalUserDataFormParams.get('selectedVideoType').value || []"
                                        formControlName="selectedType"
                                        placeholder="{{translations.lbl_select}} {{translations.lbl_video}} {{translations.lbl_type}}"
                                        optionLabel="descrip" optionValue="id.fieldId" [showClear]="true">
                                    </p-dropdown>
                                </div>
                            </div>
                        </div>

                        <!-- ITEM ID -->
                        <div class="p-col-12">
                            <div class="p-formgrid p-grid p-ai-center p-jc-between">
                                <div class="subTitle p-col-12 p-md-4">
                                    <span>{{ translations.lbl_item }}<span
                                            *ngIf="globalUserDataFormParams.get('selectedItemId').value == null"
                                            style="color:red">
                                            (*)</span></span>
                                </div>

                                <div class="p-col-12 p-md-8">
                                    <p-dropdown id="selectedItemCat3"
                                        [options]="this.globalUserDataFormParams.get('selectedItemCat3').value || []"
                                        formControlName="selectedItemId"
                                        placeholder="{{translations.lbl_select}} {{translations.lbl_item}}"
                                        optionLabel="value" optionValue="valueId" [showClear]="true">
                                    </p-dropdown>

                                </div>
                            </div>
                        </div>

                        <!-- LANGUAGE ID -->
                        <div class="p-col-12">
                            <div class="p-formgrid p-grid p-ai-center p-jc-between">
                                <div class="subTitle p-col-12 p-md-4">
                                    <span>{{ translations.lbl_language }}<span
                                            *ngIf="globalUserDataFormParams.get('selectedLanguageVideo').value == null"
                                            style="color:red">
                                            (*)</span></span>
                                </div>

                                <div class="p-col-12 p-md-8">
                                    <p-dropdown id="selectedLanguageList"
                                        [options]="this.globalUserDataFormParams.get('selectedLanguageList').value || []"
                                        formControlName="selectedLanguageVideo"
                                        placeholder="{{translations.lbl_select}} {{translations.lbl_language}}"
                                        optionLabel="descrip" optionValue="id.fieldVal" [showClear]="true">
                                    </p-dropdown>
                                </div>
                            </div>
                        </div>

                        <!-- LINK ID -->
                        <div class="p-col-12">
                            <div class="p-formgrid p-grid p-ai-center p-jc-between">
                                <div class="subTitle p-col-12 p-md-4">
                                    <span>{{ translations.lbl_link +' '+translations.lbl_video}}<span
                                            *ngIf="globalUserDataFormParams.get('selectedLink').value == null"
                                            style="color:red">
                                            (*)</span></span>
                                </div>

                                <div class="p-col-12 p-md-8">
                                    <input id="selectedLink" formControlName="selectedLink"
                                        placeholder="Solo alfanumericos (letras y numeros)" type="text" maxlength="50"
                                        pInputText>
                                </div>
                            </div>
                        </div>

                        <!-- VIDEO PICTURE ID -->
                        <div class="p-col-12">
                            <div class="p-formgrid p-grid p-ai-center p-jc-between">
                                <div class="subTitle p-col-12 p-md-4">
                                    <span>{{ translations.lbl_video_picture }}<span
                                            *ngIf="globalUserDataFormParams.get('selectedVideopicture').value == null"
                                            style="color:red">
                                            (*)</span></span>
                                </div>

                                <div class="p-col-12 p-md-8">
                                    <input id="selectedVideopicture" formControlName="selectedVideopicture"
                                        placeholder="Solo alfanumericos (letras y numeros)" type="text" maxlength="50"
                                        pInputText>
                                </div>
                            </div>
                        </div>


                        <!-- VIDEO PICTURE ID -->
                        <div class="p-col-12">
                            <div class="p-formgrid p-grid p-ai-center p-jc-between">
                                <div class="subTitle p-col-12 p-md-4">
                                    <span>{{ translations.lbl_path }}<span
                                            *ngIf="globalUserDataFormParams.get('selectedVideoPath').value == null"
                                            style="color:red">
                                            (*)</span></span>
                                </div>

                                <div class="p-col-12 p-md-8">
                                    <input id="selectedVideoPath" formControlName="selectedVideoPath"
                                        placeholder="Solo alfanumericos (letras y numeros)" type="text" maxlength="50"
                                        pInputText>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- End 1st Section -->

                <!-- 2nd Section -->
                <div class="p-col-12 p-md-6 p-lg-6">
                    <div class="p-fluid">
                        <!-- URI ID -->
                        <div class="p-col-12">
                            <div class="p-formgrid p-grid p-ai-center p-jc-between">
                                <div class="subTitle p-col-12 p-md-4">
                                    <span>{{ translations.lbl_uri }}<span
                                            *ngIf="globalUserDataFormParams.get('selectedUri').value == null"
                                            style="color:red">
                                            (*)</span></span>
                                </div>

                                <div class="p-col-12 p-md-8">
                                    <input id="selectedUri" formControlName="selectedUri"
                                        placeholder="Solo alfanumericos (letras y numeros)" type="text" maxlength="50"
                                        pInputText>
                                </div>
                            </div>
                        </div>

                        <!-- PLAYER EMBED URL PICTURE ID -->
                        <div class="p-col-12">
                            <div class="p-formgrid p-grid p-ai-center p-jc-between">
                                <div class="subTitle p-col-12 p-md-4">
                                    <span>{{ translations.lbl_player_embed_url }}<span
                                            *ngIf="globalUserDataFormParams.get('selectedPlayerEmbedURL').value == null"
                                            style="color:red">
                                            (*)</span></span>
                                </div>

                                <div class="p-col-12 p-md-8">
                                    <input id="selectedPlayerEmbedURL" formControlName="selectedPlayerEmbedURL"
                                        placeholder="Solo alfanumericos (letras y numeros)" type="text" maxlength="50"
                                        pInputText>
                                </div>
                            </div>
                        </div>

                        <!-- PLAYER EMBED URL 360 PICTURE ID -->
                        <div class="p-col-12">
                            <div class="p-formgrid p-grid p-ai-center p-jc-between">
                                <div class="subTitle p-col-12 p-md-4">
                                    <span>{{ translations.lbl_download_cdn_video_360 }}<span
                                            *ngIf="globalUserDataFormParams.get('selectedDownloadCdnVideo360').value == null"
                                            style="color:red">
                                            (*)</span></span>
                                </div>

                                <div class="p-col-12 p-md-8">
                                    <input id="selectedDownloadCdnVideo360"
                                        formControlName="selectedDownloadCdnVideo360"
                                        placeholder="Solo alfanumericos (letras y numeros)" type="text" maxlength="50"
                                        pInputText>
                                </div>
                            </div>
                        </div>

                        <!-- PLAYER EMBED URL 720 PICTURE ID -->
                        <div class="p-col-12">
                            <div class="p-formgrid p-grid p-ai-center p-jc-between">
                                <div class="subTitle p-col-12 p-md-4">
                                    <span>{{ translations.lbl_add + ' ' + translations.lbl_download_cdn_video_720
                                        }}<span
                                            *ngIf="globalUserDataFormParams.get('selectedDownloadCdnVideo720').value == null"
                                            style="color:red">
                                            (*)</span></span>
                                </div>

                                <div class="p-col-12 p-md-8">
                                    <input id="selectedDownloadCdnVideo720"
                                        formControlName="selectedDownloadCdnVideo720"
                                        placeholder="Solo alfanumericos (letras y numeros)" type="text" maxlength="50"
                                        pInputText>
                                </div>
                            </div>
                        </div>

                        <!-- DURATION ID >
                        <div class="p-col-12 p-md-4 p-lg-4">
                            <div class="p-formgrid p-grid p-ai-center p-jc-between">
                                <div class="subTitle p-col-12 p-md-4">
                                    <span>{{ translations.lbl_duration }}<span
                                            *ngIf="globalUserDataFormParams.get('selectedDuration').value == null"
                                            style="color:red">
                                            (*)</span></span>
                                </div>

                                <div class="p-col-12 p-md-8">
                                    <p-inputNumber id="selectedDuration" formControlName="selectedDuration"
                                        inputId="withoutgrouping" [useGrouping]="false" [showButtons]="true"
                                        placeholder="Solo alfanumericos (letras y numeros)" [showButtons]="true" [min]="0"
                                        [max]="99999999"></p-inputNumber>
                                </div>
                            </div>
                        </div-->

                        <!-- WIDTH ID >
                        <div class="p-col-12 p-md-4 p-lg-4">
                            <div class="p-formgrid p-grid p-ai-center p-jc-between">
                                <div class="subTitle p-col-12 p-md-4">
                                    <span>{{ translations.lbl_width }}<span
                                            *ngIf="globalUserDataFormParams.get('selectedWidth').value == null"
                                            style="color:red">
                                            (*)</span></span>
                                </div>
    
                                <div class="p-col-12 p-md-8">
                                    <p-inputNumber id="selectedWidth" formControlName="selectedWidth" inputId="withoutgrouping"
                                        [useGrouping]="false" [showButtons]="true"
                                        placeholder="Solo alfanumericos (letras y numeros)" [showButtons]="true" [min]="0"
                                        [max]="99999999"></p-inputNumber>
                                </div>
                            </div>
                        </div-->

                        <!-- HEIGHT ID >
                        <div class="p-col-12 p-md-3 p-lg-3">
                            <div class="p-formgrid p-grid p-ai-center p-jc-between">
                                <div class="subTitle p-col-12 p-md-4">
                                    <span>{{ translations.lbl_height }}<span
                                            *ngIf="globalUserDataFormParams.get('selectedHeight').value == null"
                                            style="color:red">
                                            (*)</span></span>
                                </div>

                                <div class="p-col-12 p-md-8">
                                    <p-inputNumber id="selectedHeight" formControlName="selectedHeight"
                                        inputId="withoutgrouping" [useGrouping]="false" [showButtons]="true"
                                        placeholder="Solo alfanumericos (letras y numeros)" [showButtons]="true" [min]="0"
                                        [max]="99999999"></p-inputNumber>
                                </div>
                            </div>
                        </div-->

                    </div>
                </div>


            </div>
        </div>
    </div>
</div>